// extracted by mini-css-extract-plugin
export default {"main":"register-layout_main__OFPNI","content":"register-layout_content__RJblG"};